module.exports = __webpack_public_path__ + "first-10-hologram.jpg?b56234adb411fbd4e13b16b08c3bc34d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-hologram.jpg
// module id = 401
// module chunks = 0